<custom-modal [(open)]="isOpenModal" [header]="'LABELS.THANK_YOU'" (openChange)="onDecline()" [modalClass]="'verification'">
  <ng-container *ngIf="!verifyCompleted; else verified">
    <div class="f-bold">{{ "LABELS.ENTER_DIGIT" | translate }}</div>
    <span>{{ phone }}</span>
    <div class="input-code">
      <ng-container *ngFor="let i of [0, 1, 2, 3, 4, 5]; let first = first">
        <input
          class="code"
          type="number"
          maxlength="1"
          size="1"
          [appFocus]="isOpenModal && first"
          [id]="i"
          inputmode="decimal"
          (keydown)="onKey($event)"
        />
      </ng-container>
    </div>
    <p class="paragraph">
      <span *ngIf="!invalidCode">{{ "DIDNT_RECEIVE_CODE" | translate }}</span>
      <span *ngIf="invalidCode" class="invalid-verification">{{ "INVALID_VERIFICATION_CODE" | translate }}</span>
      <a href (click)="resend($event)">{{ "BUTTON.RESEND_CODE" | translate }}</a>
    </p>
  </ng-container>
  <ng-template #verified>
    <div class="verify-body">
      <div class="check-icon">
        <img alt="check" src="assets/icons/check.svg" />
      </div>
      <div>
        <div class="f-bold">{{ "LABELS.MOBILE_WAS_VERIFIED" | translate }}</div>
        <span class="f-bold">{{ phone }}</span>
      </div>
    </div>
  </ng-template>
  <button footer-action type="button" *ngIf="verifyCompleted" class="btn btn-secondary" (click)="onConfirm()">
    {{ "BUTTON.CLOSE" | translate }}
  </button>
  <button footer-action type="button" *ngIf="!verifyCompleted" class="btn btn-primary" (click)="verifyPhone()">
    {{ "BUTTON.VERIFY" | translate }}
  </button>
</custom-modal>
